// @flow

export const studentSubsidyTypes = Object.freeze({
  WithSubsidies: 'with_subsidies',
  WithoutSubsidies: 'without_subsidies',
});

export type StudentSubsidyType = $Values<typeof studentSubsidyTypes>
